module.exports = __webpack_public_path__ + "7aaa07614e1b624a17db2a9293024e3b.png";